import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { routes } from '../config';
import Home from '../pages/Home';
import Login from '../pages/Login';
import OTP from '../pages/OTP';
import Register from '../pages/Register';
import ReferralCode from '../pages/ReferralCode';
import ReferFriend from '../pages/ReferFriend';
import RegisterSuccess from '../pages/RegisterSuccess';
import AddToWallet from '../pages/AddToWallet';
import CouponDetail from '../pages/CouponDetail';
import AuthGuard from '../components/AuthGuard';
import type { AppRoutesProps, Customer, FirebaseUser } from '../types';

interface ExtendedAppRoutesProps extends Omit<AppRoutesProps, 'currentUser'> {
  currentUser: Customer | null;
  firebaseUser: FirebaseUser | null;
}

function AppRoutesContent({
  currentUser,
  registerFormData,
  firebaseUser,
  onBack,
  onBackToLogin,
}: ExtendedAppRoutesProps) {
  const navigate = useNavigate();

  return (
    <Box sx={{ height: '100svh' }}>
      <Routes>
        <Route 
          path={routes.login} 
          element={
            <Login />
          } 
        />
        <Route 
          path={routes.otp} 
          element={
            <OTP />
          } 
        />
        <Route 
          path={routes.register} 
          element={
            <Register 
              firebaseUser={firebaseUser}
              onBack={onBackToLogin}
              initialFormData={registerFormData}
            />
          } 
        />
        <Route 
          path={routes.registerSuccess} 
          element={
            <RegisterSuccess 
              onContinue={() => navigate(routes.addToWallet)}
            />
          } 
        />
        <Route 
          path={routes.addToWallet} 
          element={
            <AuthGuard currentUser={currentUser} firebaseUser={firebaseUser}>
              <AddToWallet
                onContinue={() => navigate(routes.home)}
              />
            </AuthGuard>
          } 
        />
        <Route 
          path={routes.referralCode} 
          element={
            <AuthGuard currentUser={currentUser} firebaseUser={firebaseUser}>
              <ReferralCode
                onBack={onBack}
              />
            </AuthGuard>
          }
        />
        <Route 
          path={routes.referFriend} 
          element={
            <AuthGuard currentUser={currentUser} firebaseUser={firebaseUser}>
              <ReferFriend
                user={currentUser!}
                onBack={onBack}
              />
            </AuthGuard>
          } 
        />
        <Route 
          path={routes.couponDetail} 
          element={
            <AuthGuard currentUser={currentUser} firebaseUser={firebaseUser}>
              <CouponDetail />
            </AuthGuard>
          } 
        />
        <Route 
          path={routes.home} 
          element={
            <AuthGuard currentUser={currentUser} firebaseUser={firebaseUser}>
              <Home user={currentUser!} />
            </AuthGuard>
          } 
        />
        <Route path="*" element={<Navigate to={routes.home} replace />} />
      </Routes>
    </Box>
  );
}

export default function AppRoutes(props: ExtendedAppRoutesProps) {
  return <AppRoutesContent {...props} />;
} 